import React from 'react';
import styles from './Input.css';

function Input(props) {
  const { label, errorMessage, children, ...rest } = props;
  return (
    <div className={styles.wrapper}>
      <p className={styles.label}>{label}</p>
      {children || (
        <input
          className={`${styles.input} ${errorMessage &&
            styles['border-error']}`}
          {...rest}
          data-testid="input"
        />
      )}
      {errorMessage && <p className={styles.error}>{errorMessage}</p>}
    </div>
  );
}

export default Input;
